
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("dSv73"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("dSv73", function(module, exports) {

let $a1a873dcb1116a94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a1a873dcb1116a94$var$load("h3ABO"),
    $a1a873dcb1116a94$var$load("djHM5"),
    $a1a873dcb1116a94$var$load("eJQji"),
    $a1a873dcb1116a94$var$load("2YffH"),
    $a1a873dcb1116a94$var$load("6mHrv"),
    $a1a873dcb1116a94$var$load("awWN9"),
    $a1a873dcb1116a94$var$load("9CYct"),
    $a1a873dcb1116a94$var$load("bRKjd"),
    $a1a873dcb1116a94$var$load("ap5Gz"),
    $a1a873dcb1116a94$var$load("hZtKG"),
    $a1a873dcb1116a94$var$load("iNmaF"),
    $a1a873dcb1116a94$var$load("lVO3w"),
    $a1a873dcb1116a94$var$load("hyzoX"),
    $a1a873dcb1116a94$var$load("h9Ed7"),
    $a1a873dcb1116a94$var$load("eBRUf"),
    $a1a873dcb1116a94$var$load("b2zxR"),
    $a1a873dcb1116a94$var$load("tKhaz"),
    $a1a873dcb1116a94$var$load("5eNHu"),
    $a1a873dcb1116a94$var$load("6iBAZ"),
    $a1a873dcb1116a94$var$load("cD6Zr"),
    $a1a873dcb1116a94$var$load("fPSgL"),
    $a1a873dcb1116a94$var$load("aDOZ4"),
    $a1a873dcb1116a94$var$load("9wzNh"),
    $a1a873dcb1116a94$var$load("8YSo7"),
    $a1a873dcb1116a94$var$load("3Zfzp"),
    $a1a873dcb1116a94$var$load("Wowvf"),
    $a1a873dcb1116a94$var$load("9ldRJ"),
    $a1a873dcb1116a94$var$load("9anPW"),
    $a1a873dcb1116a94$var$load("50ame"),
    $a1a873dcb1116a94$var$load("e7ZUf"),
    $a1a873dcb1116a94$var$load("gL8bn"),
    $a1a873dcb1116a94$var$load("1MlIV"),
    $a1a873dcb1116a94$var$load("g9CVe"),
    $a1a873dcb1116a94$var$load("7oiUM"),
    $a1a873dcb1116a94$var$load("8t3po"),
    $a1a873dcb1116a94$var$load("855o0"),
    $a1a873dcb1116a94$var$load("8MfZE"),
    $a1a873dcb1116a94$var$load("hv4mn"),
    $a1a873dcb1116a94$var$load("dek7I"),
    $a1a873dcb1116a94$var$load("dYtBN"),
    $a1a873dcb1116a94$var$load("6wr18"),
    $a1a873dcb1116a94$var$load("kjZZD"),
    $a1a873dcb1116a94$var$load("2zxmz"),
    $a1a873dcb1116a94$var$load("7269o"),
    $a1a873dcb1116a94$var$load("gizWr"),
    $a1a873dcb1116a94$var$load("4PUiY"),
    $a1a873dcb1116a94$var$load("37ldp"),
    $a1a873dcb1116a94$var$load("ffEVr"),
    $a1a873dcb1116a94$var$load("dRpV3"),
    $a1a873dcb1116a94$var$load("dTsOE"),
    $a1a873dcb1116a94$var$load("hhss7"),
    $a1a873dcb1116a94$var$load("jwTn5"),
    $a1a873dcb1116a94$var$load("aYdgM"),
    $a1a873dcb1116a94$var$load("jY21r"),
    $a1a873dcb1116a94$var$load("8fMw3"),
    $a1a873dcb1116a94$var$load("hogcU"),
    $a1a873dcb1116a94$var$load("8Vzcw"),
    $a1a873dcb1116a94$var$load("co52j"),
    $a1a873dcb1116a94$var$load("7EorR"),
    $a1a873dcb1116a94$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.c0a77b89.js.map
